export const listPerPage = 50;

export const statusLabel: { [k: string]: string } = {
  making: '作成中',
  requesting: '依頼中',
  approved: '承認済',
  confirm: '確定',
  obtained: '入手済'
};

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace errorDefine {
  // 各例外処理のエラーコード・エラーメッセージを定義
  export const config: Array<{ errType: string; code: string; message: string }> = [
    { errType: 'type', code: '001', message: 'The type is different' },
    { errType: 'arg', code: '010', message: 'Not enough arguments' }
  ];
}
export const errorConf = errorDefine.config;
